import React, { useState, useEffect } from 'react';
import { X, Download, Users, CreditCard } from 'lucide-react';
import api from '../../api/client';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';

const labels: Record<string, string> = {
  companyName: 'Название компании', inn: 'ИНН', kpp: 'КПП', ogrn: 'ОГРН',
  address: 'Юридический адрес', bankName: 'Банк', bik: 'БИК',
  account: 'Расчетный счет', corrAccount: 'Корр. счет'
};

const CompanyBillingModal = ({ company, users, onClose }: any) => {
  const [activeTab, setActiveTab] = useState<'reqs' | 'users'>('reqs');
  const [requisites, setRequisites] = useState<any>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (company?.id) {
      api.get(`/billing/requisites/${company.id}`)
        .then(res => { setRequisites(res.data || {}); setLoading(false); })
        .catch(() => setLoading(false));
    }
  }, [company]);

  const saveRequisites = async () => {
    try {
      await api.post(`/billing/requisites/${company.id}`, requisites);
      alert('Реквизиты сохранены!');
    } catch (e) {
      alert('Ошибка сохранения');
    }
  };

  // Генерация Word с реквизитами
  const downloadRequisitesWord = () => {
    const zip = new PizZip();
    // Создаем минимальный docx на лету
    const content = `<w:p><w:r><w:t>Карточка компании: ${requisites.companyName || company.name}</w:t></w:r></w:p>
      <w:p><w:r><w:t>ИНН: ${requisites.inn || ''}</w:t></w:r></w:p>
      <w:p><w:r><w:t>КПП: ${requisites.kpp || ''}</w:t></w:r></w:p>
      <w:p><w:r><w:t>ОГРН: ${requisites.ogrn || ''}</w:t></w:r></w:p>
      <w:p><w:r><w:t>Адрес: ${requisites.address || ''}</w:t></w:r></w:p>
      <w:p><w:r><w:t>Банк: ${requisites.bankName || ''}</w:t></w:r></w:p>
      <w:p><w:r><w:t>БИК: ${requisites.bik || ''}</w:t></w:r></w:p>
      <w:p><w:r><w:t>Р/С: ${requisites.account || ''}</w:t></w:r></w:p>
      <w:p><w:r><w:t>К/С: ${requisites.corrAccount || ''}</w:t></w:r></w:p>`;
    
    // Создаем простую структуру docx
    const docXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
      <w:document xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main">
        <w:body>${content}</w:body>
      </w:document>`;
    
    zip.file("[Content_Types].xml", `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/word/document.xml" ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"/></Types>`);
    zip.file("_rels/.rels", `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="word/document.xml"/></Relationships>`);
    zip.file("word/document.xml", docXml);

    const out = zip.generate({ type: 'blob' });
    saveAs(out, `Реквизиты_${company.name}.docx`);
  };

  if (!company) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.6)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }} onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: 24, width: '100%', maxWidth: 800, maxHeight: '90vh', overflow: 'auto', position: 'relative' }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: '24px 32px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: '#fff', zIndex: 10 }}>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 800 }}>{company.name}</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b' }}><X size={24} /></button>
        </div>

        <div style={{ padding: '24px 32px' }}>
          <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
            <button onClick={() => setActiveTab('reqs')} style={{ padding: '8px 16px', borderRadius: 8, background: activeTab === 'reqs' ? '#2575fc' : '#f1f5f9', color: activeTab === 'reqs' ? '#fff' : '#475569', border: 'none', fontWeight: 600, cursor: 'pointer' }}>Реквизиты</button>
            <button onClick={() => setActiveTab('users')} style={{ padding: '8px 16px', borderRadius: 8, background: activeTab === 'users' ? '#2575fc' : '#f1f5f9', color: activeTab === 'users' ? '#fff' : '#475569', border: 'none', fontWeight: 600, cursor: 'pointer' }}>Пользователи ({users.filter((u:any) => u.companyName === company.name || u.company === company.name || u.companyId === company.id).length})</button>
          </div>

          {activeTab === 'reqs' && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                <h3 style={{ margin: 0, fontSize: 18 }}>Данные компании</h3>
                <button onClick={downloadRequisitesWord} style={{ padding: '8px 16px', background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}><Download size={16} /> Скачать в Word</button>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                {Object.keys(labels).map(key => (
                  <div key={key}>
                    <label style={{ display: 'block', fontSize: 13, color: '#475569', marginBottom: 4 }}>{labels[key]}</label>
                    <input type="text" value={requisites[key] || ''} onChange={e => setRequisites({...requisites, [key]: e.target.value})} style={{ width: '100%', padding: '10px 14px', borderRadius: 12, border: '1px solid #cbd5e1' }} />
                  </div>
                ))}
              </div>
              <button onClick={saveRequisites} style={{ marginTop: 24, padding: '12px 24px', background: '#2575fc', color: '#fff', border: 'none', borderRadius: 12, fontWeight: 600, cursor: 'pointer' }}>Сохранить реквизиты</button>
            </div>
          )}

          {activeTab === 'users' && (
            <div>
              <h3 style={{ margin: '0 0 16px 0', fontSize: 18 }}>Сотрудники компании</h3>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                <thead><tr style={{ background: '#f8fafc', textAlign: 'left' }}><th style={{ padding: 12 }}>Имя</th><th style={{ padding: 12 }}>Email</th><th style={{ padding: 12 }}>Тариф</th></tr></thead>
                <tbody>
                  {users.filter((u:any) => u.companyName === company.name || u.company === company.name || u.companyId === company.id).map((u:any) => (
                    <tr key={u.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: 12 }}>{u.name || 'Без имени'}</td>
                      <td style={{ padding: 12 }}>{u.email}</td>
                      <td style={{ padding: 12 }}>{u.paid ? 'Оплачен' : 'Демо'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyBillingModal;
